// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ImageDisplayNode 样式 */
.ImageDisplayNode-wrapper {
  width: 280px;
}

.ImageDisplayNode-preview {
  position: relative;
}

.ImageDisplayNode-image {
  width: 100%;
  border-radius: 8px;
  display: block;
  border: 1px solid #ddd;
}

.ImageDisplayNode-download {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 8px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: white;
  font-size: 16px;
  transition: background 0.2s;
}

.ImageDisplayNode-download:hover {
  background: rgba(0, 0, 0, 0.9);
}

.ImageDisplayNode-filename {
  margin-top: 8px;
  font-size: 11px;
  color: #666;
  word-break: break-all;
}

.ImageDisplayNode-metadata {
  margin-top: 8px;
  padding: 8px;
  background: #f9fafb;
  border-radius: 6px;
  font-size: 11px;
  color: #666;
}

.ImageDisplayNode-status {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 32px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.ImageDisplayNode-generating {
  background: #f9fafb;
}

.ImageDisplayNode-failed {
  background: #fee;
}

.ImageDisplayNode-empty {
  background: white;
}

.ImageDisplayNode-loading {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  animation: ImageDisplayNode-spin 1s linear infinite;
}

@keyframes ImageDisplayNode-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.ImageDisplayNode-error-icon {
  font-size: 32px;
  color: #e53e3e;
}

.ImageDisplayNode-icon {
  color: #999;
}

.ImageDisplayNode-text {
  font-size: 13px;
  color: #666;
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/ImageDisplayNode.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":["/* ImageDisplayNode 样式 */\n.ImageDisplayNode-wrapper {\n  width: 280px;\n}\n\n.ImageDisplayNode-preview {\n  position: relative;\n}\n\n.ImageDisplayNode-image {\n  width: 100%;\n  border-radius: 8px;\n  display: block;\n  border: 1px solid #ddd;\n}\n\n.ImageDisplayNode-download {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  padding: 8px;\n  background: rgba(0, 0, 0, 0.7);\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: white;\n  font-size: 16px;\n  transition: background 0.2s;\n}\n\n.ImageDisplayNode-download:hover {\n  background: rgba(0, 0, 0, 0.9);\n}\n\n.ImageDisplayNode-filename {\n  margin-top: 8px;\n  font-size: 11px;\n  color: #666;\n  word-break: break-all;\n}\n\n.ImageDisplayNode-metadata {\n  margin-top: 8px;\n  padding: 8px;\n  background: #f9fafb;\n  border-radius: 6px;\n  font-size: 11px;\n  color: #666;\n}\n\n.ImageDisplayNode-status {\n  border: 2px dashed #ddd;\n  border-radius: 8px;\n  padding: 32px 16px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.ImageDisplayNode-generating {\n  background: #f9fafb;\n}\n\n.ImageDisplayNode-failed {\n  background: #fee;\n}\n\n.ImageDisplayNode-empty {\n  background: white;\n}\n\n.ImageDisplayNode-loading {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #667eea;\n  border-radius: 50%;\n  animation: ImageDisplayNode-spin 1s linear infinite;\n}\n\n@keyframes ImageDisplayNode-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.ImageDisplayNode-error-icon {\n  font-size: 32px;\n  color: #e53e3e;\n}\n\n.ImageDisplayNode-icon {\n  color: #999;\n}\n\n.ImageDisplayNode-text {\n  font-size: 13px;\n  color: #666;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
